import { Dialog } from 'primereact/dialog';
import { useState } from 'react';
import { TagOption } from './AlphaEpCatalogTaggingDialog';
import BeeDropDown from '../../Atoms/BeeDropDown';
import BeeButton from '../../Atoms/BeeButton';

type BulkTagDialogProps = {
  visible: boolean;
  categoryTitle: string;
  affectedCount: number;
  tagOptions: TagOption[];
  disabled: boolean;
  onCancel: () => void;
  onConfirm: (option: TagOption | null) => void;
};
export default function AlphaBulkTagDialog({
  visible,
  categoryTitle,
  affectedCount,
  tagOptions,
  disabled,
  onCancel,
  onConfirm
}: BulkTagDialogProps) {
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  const canConfirm =
    !!selectedValue &&
    affectedCount > 0 &&
    !disabled &&
    tagOptions.length > 0;

  function handleChange(value: string | null) {
    setSelectedValue(value);
  }

  function handleConfirm() {
    const option =
      tagOptions.find((o) => o.value === selectedValue) ?? null;
    onConfirm(option);
  }

  return (
    <Dialog
      header={'Leistungscluster auf Kategorie anwenden'}
      visible={visible}
      modal={true}
      className={'bee-dialog-medium bee-dialog-primary'}
      onHide={() => onCancel()}
    >
      <div className={'mb-3 text-color-secondary'}>
        <p className={'text-sm mb-2'}>
          Wählen Sie einen Leistungscluster, der auf alle Unterpositionen der
          Kategorie <span className={'font-semibold'}>{categoryTitle}</span>{' '}
          angewendet werden soll.
        </p>
        <p className={'text-xs m-0'}>
          Es werden {affectedCount} Positionen überschrieben.
        </p>
      </div>
      <div className={'mb-3'}>
        <BeeDropDown
          value={selectedValue}
          options={tagOptions}
          optionLabel={'label'}
          readOnly={false}
          disabled={disabled}
          onChange={(value: string) => handleChange(value ?? null)}
        />
      </div>
      <div className={'flex justify-content-end gap-2'}>
        <BeeButton
          type={'secondary'}
          label={'Abbrechen'}
          onClick={() => onCancel()}
        />
        <BeeButton
          type={'primary'}
          label={'Übernehmen'}
          disabled={!canConfirm}
          onClick={() => handleConfirm()}
        />
      </div>
    </Dialog>
  );
}
